<template>
<div>
  <!-- Site footer -->
  <footer class="site-footer">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <p class="copyright-text">
            This project is no longer active. If you had staked NFTs in the past, 
            you can unstake them here to transfer back to your wallet.
          </p>
        </div>
      </div>
    </div>
  </footer>
</div>
</template>

<script>
export default {
    name: "Footer",
    methods:{

    }
}
</script>

<style scoped>
.site-footer {
  background-color: #4ad2ee;
  padding: 45px 0 20px;
  font-size: 15px;
  line-height: 24px;
  color: #737373;
}

.copyright-text {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  color: #333;
  text-align: center;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
}

.row {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60px;
}

.col-12 {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 768px) {
  .copyright-text {
    font-size: 16px;
    padding: 0 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Navigation/Footer.vue